// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "../styles/Theme.bs.js";
import * as React from "react";
import * as Emotion from "../bindings/Emotion.bs.js";
import * as Typography from "../components/Typography/Typography.bs.js";
import * as AuthContext from "../context/AuthContext.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function CallbackPage(props) {
  let auth = AuthContext.useAuth();
  React.useEffect(() => {
    let search = window.location.search;
    if (search.length > 0) {
      auth.handleCallback(search).then(() => {
        RescriptReactRouter.push("/login");
        return Promise.resolve();
      });
    } else {
      RescriptReactRouter.push("/login");
    }
  }, []);
  let containerStyles = Emotion.Css.css({
    padding: "4rem 1rem",
    maxWidth: "400px",
    margin: "0 auto",
    textAlign: "center"
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Typography.Typography.Display.make, {
        size: "2xl",
        children: "Signing in..."
      }),
      JsxRuntime.jsx(Typography.Typography.Body.make, {
        className: Emotion.Css.css({
          marginTop: "1rem",
          color: Theme.Theme.Colors.text.secondary
        }),
        children: "Completing authentication."
      })
    ],
    className: containerStyles
  });
}

let Typography$1;

let make = CallbackPage;

export {
  Typography$1 as Typography,
  make,
}
/* Theme Not a pure module */
